import { AbstractDimension } from '@orus.eu/dimensions'
import { type EsMrpaxeQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

/** The tariff failed: `reason` is the type of its `EsMrpaxeTariffFailure`, a configuration error. */
export type EsMrpaxeQuoteFailure = { type: 'pricing-issue'; reason: string }
export type EsMrpaxeQuoteResult = Result<EsMrpaxeQuote, EsMrpaxeQuoteFailure>

export class EsMrpaxeQuoteDimension<NAME extends string> extends AbstractDimension<NAME, EsMrpaxeQuoteResult> {
  override formatToString(value: EsMrpaxeQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const esMrpaxeQuoteDimension = new EsMrpaxeQuoteDimension({
  name: 'esMrpaxeQuote',
  displayKeys: { name: 'dimension_name_es_mrpaxe_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
